import RoutesUtils from './../../js/RoutesUtils.js';

/**
 * Quién puede entrar en **Control de Planificación**. Una sola lista, que usan su ruta y la tarjeta
 * del Cuadro de mandos que lleva a ella, para que las dos no contesten cosas distintas.
 *
 * El precedente y el porqué están en `src/pages/calendario/permisos.js` y en
 * `src/pages/empleados/permisos.js`: cuatro copias de la misma lista respondían distinto y el
 * enlace acababa en un 403.
 */
export const ROLES_CONTROL_PLANIFICACION = ['ADMIN', 'PLANIFICADOR'];

/** La ruta de la pantalla. En un sitio porque la miran la ruta, la tarjeta y la prueba. */
export const RUTA_CONTROL_PLANIFICACION = '/dashboard/control-planificacion/';

/**
 * ¿Puede esta persona abrir Control de Planificación?
 *
 * **Manda el menú de Mongo, no el rol**: `RoutesUtils.tieneAcceso` solo cae en la lista de roles
 * mientras el menú no esté cargado, así que ser ADMIN no basta si la ruta no cuelga de su menú
 * efectivo — que es justo el caso que produce el 403 (`CLAUDE.md` §9 del orquestador, de la #69).
 *
 * Lo usa la tarjeta de OEB Producción: si devuelve `false`, la tarjeta NO se dibuja. Un botón que
 * lleva a un 403 es peor que no tener botón.
 */
export function puedeAbrirControlPlanificacion() {
    return RoutesUtils.tieneAcceso(RUTA_CONTROL_PLANIFICACION, ROLES_CONTROL_PLANIFICACION);
}

export default {
    ROLES_CONTROL_PLANIFICACION,
    RUTA_CONTROL_PLANIFICACION,
    puedeAbrirControlPlanificacion
};
